import {
  ABANDONED_CART_WIDGET,
  getSubscriptionScriptDescriptors,
  TinypassSDK,
} from "@product/rosetta-sdk";
import Script from "next/script";
import { useEffect } from "react";

import { config } from "shared/data";

export const RosettaScripts = () => {
  const environment = config.rosetta.environment;
  const widgetBaseURL = config.rosetta.subscribeTemplateHost;

  // Kick off ad-block detection as soon as possible so the __adblocker cookie
  // is set before RosettaSDK.init() executes Piano Experience.
  useEffect(() => {
    void TinypassSDK.loadAdBlockDetectionScript();
  }, []);

  const descriptors = getSubscriptionScriptDescriptors({
    environment: environment === "production" ? "production" : "development",
    widgetBaseURL,
    widgets: [ABANDONED_CART_WIDGET],
  });

  return (
    <>
      {descriptors.map(({ id, onLoad, ...descriptors }) => (
        <Script key={id} {...descriptors} onReady={onLoad} />
      ))}
    </>
  );
};

RosettaScripts.displayName = "RosettaScripts";
